module.exports = __webpack_public_path__ + "img/DFM2.2d66926e.svg";